type ImpresionConfig = {
  ImpresionConCorte?: string | number;
};

let cachedImpresionConCorte: 0 | 1 = 0;

export function setImpresionConCorteFromConfig(
  impresion?: ImpresionConfig | null
): void {
  const raw = impresion?.ImpresionConCorte;
  cachedImpresionConCorte = raw === '1' || raw === 1 ? 1 : 0;
}

export function getImpresionConCorte(): 0 | 1 {
  return cachedImpresionConCorte;
}

export function canPrintPDFWithExternal(): boolean {
  const win = window as any;
  return (
    win.external && typeof win.external.imprimirPDFBinario === 'function'
  );
}

export function imprimirPDFBinarioExterno(
  base64: string,
  tipoDocumento: string,
  conCorte?: 0 | 1
): void {
  const corte = conCorte ?? getImpresionConCorte();
  if (!canPrintPDFWithExternal()) {
    return;
  }
  (window as any).external.imprimirPDFBinario(
    base64,
    tipoDocumento,
    '',
    '',
    corte
  );
}
